import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { ExpiresAtDisplay, ShelfLifeDisplay } from "./expirydisplay";
import { WeightDisplay } from "./weightdisplay";
import { ProductStock } from "../../shared/types";
import { stockLocationDisplayName } from "../../shared/stock-location-display-name";

interface StockTableProps {
    stock: ProductStock[];
    emptyMessage?: string;
}

export default function StockTable({ stock, emptyMessage = "No stock found." }: StockTableProps) {
    return (
        <Card variant="outlined">
            <CardContent>
                {stock.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
                        {emptyMessage}
                    </Typography>
                ) : (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Warehouse</TableCell>
                                <TableCell>Location</TableCell>
                                <TableCell>Position</TableCell>
                                <TableCell>Quantity</TableCell>
                                <TableCell>Weight</TableCell>
                                <TableCell>Shelf Life</TableCell>
                                <TableCell>Expires</TableCell>
                                <TableCell>Best Before</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stock.map((s) => (
                                <TableRow key={s.id}>
                                    <TableCell>{s.location.warehouse.name}</TableCell>
                                    <TableCell>{s.location.name}</TableCell>
                                    <TableCell>{stockLocationDisplayName(s.location, s.level, s.column)}</TableCell>
                                    <TableCell>{s.quantity > 0 ? `${s.quantity}` : '-'}</TableCell>
                                    <TableCell><WeightDisplay value={s.weight} /></TableCell>
                                    <TableCell>
                                        <ShelfLifeDisplay value={s.shelf_life} />
                                    </TableCell>
                                    <TableCell>
                                        <ExpiresAtDisplay value={s.expires_at} />
                                    </TableCell>
                                    <TableCell>{s.best_before_code ?? '-'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </CardContent>
        </Card>
    );
}

export function StockTableSkeleton() {
    return (
        <Card variant="outlined">
            <CardContent>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Location</TableCell>
                            <TableCell>Warehouse</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Weight</TableCell>
                            <TableCell>Expires</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.from({ length: 3 }).map((_, i) => (
                            <TableRow key={i}>
                                <TableCell><Skeleton variant="text" /></TableCell>
                                <TableCell><Skeleton variant="text" /></TableCell>
                                <TableCell><Skeleton variant="text" /></TableCell>
                                <TableCell><Skeleton variant="text" /></TableCell>
                                <TableCell><Skeleton variant="text" /></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}
